import { CodeSyntax } from '@carbon/pictograms-react';
import { NetworkServices } from '@carbon/pictograms-react';
import { CarbonForIbmDotcom } from '@carbon/pictograms-react';
import { Kubernetes } from '@carbon/pictograms-react';
import { Build } from '@carbon/pictograms-react';
import { Insights } from '@carbon/pictograms-react';
import { Documentation } from '@carbon/pictograms-react';
import { Reliability } from '@carbon/pictograms-react';
import { CloudTutorials } from '@carbon/pictograms-react';
import { FileBackup } from "@carbon/pictograms-react";
import { Reset } from '@carbon/pictograms-react';
import { Containers } from '@carbon/pictograms-react';
import { Docker } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  CodeSyntax,
  NetworkServices,
  CarbonForIbmDotcom,
  Kubernetes,
  Build,
  Insights,
  Documentation,
  Reliability,
  CloudTutorials,
  FileBackup,
  Reset,
  Containers,
  Docker,
  React
};